import { ActionFunction, redirect } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";
import { parseFormData } from "../../utils/parseFormData";
import { AssignmentPeriod } from "./type";

export const assignmentPeriodAction: ActionFunction = async (
  { request, params },
  context,
) => {
  const formData = await request.formData();
  const updates = parseFormData(formData, {
    booleans: ["isActive", "isEarlyStagePremium"],
    numbers: ["year", "period"],
  });
  if (params.assignmentPeriodCode === "new") {
    const result = await axiosApi.post<Result<AssignmentPeriod>>(
      "/api/assignmentPeriods",
      updates,
    );
    return redirect(
      `/assignment-periods/${result.data.data?.assignmentPeriodCode}`,
    );
  } else
    await axiosApi.put("/api/assignmentPeriods", {
      ...updates,
      assignmentPeriodCode: params.assignmentPeriodCode,
    });
  return redirect(`/assignment-periods/${params.assignmentPeriodCode}`);
};
